const commonRoadRiskCodes = ['PRO', 'PRO_2010', 'RR', 'RRT', 'RRMD', 'RR_2010', 'LMS_ROADRISK'];
const commonRoadRiskFltCodes = ['PRO_FLT_LMS', 'RR_FLT_LMS'];
const commonElearningCodes = ['OMS'];

export const culture = {
  privacy: {
    name: 'Privacy',
    codes: ['PN'],
  },
  altPrivacy: {
    name: 'Alt Privacy',
    codes: ['APN'],
  },
  policy: {
    name: 'Policy',
    codes: ['POL'],
  },
  pledge: {
    name: 'Pledge',
    codes: ['P'],
  },
  managerPledge: {
    name: 'Manager Pledge',
    codes: ['AP'],
  },
  mentorConsent: {
    name: 'Mentor Consent',
    codes: ['MC'],
  },
  authorizationToDrive: {
    name: 'Authorization To Drive',
    codes: ['ATD'],
  },
  travellingForWork: {
    name: 'Travelling For Work',
    codes: ['DW'],
  },
  tutorialVideos: {
    name: 'Tutorial Videos',
    codes: ['VID_ECOLAB1', 'VID_ECOLAB2'],
  },
  healthQuestionnaire: {
    name: 'Health Questionnaire',
    codes: ['HEQU'],
  },
  // course codes for RF are empty as theses need to be set dynamically from the API
  riskFoundation: {
    name: 'Risk Foundation',
    codes: [],
  },
  alternativeRiskFoundation: {
    name: 'Alt Risk Foundation',
    codes: ['ARF'],
  },
  driverDetails: {
    name: 'Driver Details',
    codes: ['DD', 'DD-CUMMINS'],
  },
};

export const roadRisk = {
  profileSummary: {
    name: 'Profile Summary',
    codes: commonRoadRiskCodes,
  },
  defensiveDriving: {
    name: 'Defensive Driving',
    codes: commonRoadRiskCodes,
  },
  driverRiskRating: {
    name: 'Driver Risk Rating',
    codes: commonRoadRiskCodes,
  },
  riskExposureSummary: {
    name: 'Risk Exposure Summary',
    codes: commonRoadRiskCodes,
  },
};

export const roadRiskFlt = {
  profileSummary: {
    name: 'Profile Summary',
    codes: commonRoadRiskFltCodes,
  },
  defensiveOperating: {
    name: 'Defensive Operating',
    codes: commonRoadRiskFltCodes,
  },
  operatorRiskRating: {
    name: 'Operator Risk Rating',
    codes: commonRoadRiskFltCodes,
  },
};

export const eLearning = {
  oneMoreSecond: {
    name: 'One More Second',
    codes: commonElearningCodes,
  },
};
